<template>
  <el-card>
    <unit-form :data="detailInfo" @confirm="handleEditSubmit" />
  </el-card>
</template>

<script>
import UnitForm from "@/components/unit/UnitForm";
import {request} from "@/config/request";
export default {
  name: "UnitEdit",
  components: {UnitForm},
  data() {
    return {
      detailInfo: {}
    }
  },
  methods: {
    async handleEditSubmit(data) {
      try {
        const params = Object.assign(this.detailInfo, data);
        delete params.createTime;
        delete params.updateTime;
        await request(this.$api.intellectUnit.update, params);
        this.$message.success(this.$t('操作成功'));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.intellectUnit.detail, this.$route.query);
        this.detailInfo = res.intellectUnit;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped lang="scss">



</style>
